<app-modal [modalConfig]="modalConfig">
    <div class="reset-password">
        <form [formGroup]="emailForm" (ngSubmit)="onSubmit()">
            <div class="title">
                Por favor ingresa tu correo para restablecer tu contraseña
            </div>
            <div class="input-container">
                <label>
                    Correo
                    <span class="mandatory">*</span>
                </label>
                <input class="form-input" formControlName="email" type="text" [ngClass]="{'error':hasErrors()}">
            </div>
            <button class="btn-submit" [disabled]="isLoading">Enviar</button>
        </form>
    </div>
    <ngx-ui-loader loaderId="reset-password" [hasProgressBar]="false"></ngx-ui-loader>
</app-modal>